import { render, staticRenderFns } from "./MalattieInfettiveHivDashboard.vue?vue&type=template&id=105edd64"
import script from "./MalattieInfettiveHivDashboard.vue?vue&type=script&lang=js"
export * from "./MalattieInfettiveHivDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports